import { getFinalReadOnlyMode } from "Areas/Documents/documentDetails/redux/getReadOnlyMode";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getActiveDocumentId, getActiveDocumentType, getObjects, getObjectsInProgress } from "../redux/selectors";
import TabObjects from "./tabObjects";
const mapStateToProps = (state) => ({
    inProgress: getObjectsInProgress(state),
    activeDocumentId: getActiveDocumentId(state),
    documentType: getActiveDocumentType(state),
    documentObjects: getObjects(state),
    readOnlyMode: getFinalReadOnlyMode(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(actionCreators.getObjects())
});
export default connect(mapStateToProps, mapDispatchToProps)(TabObjects);
